import { ApiEmployeeEmployment } from "@/types/employees/employee-employment.types.ts";
import { ApiEmployeeTerminationFull } from "@/types/employees/employee-termination.types.ts";
import { ApiEmployee, ApiTableRowPending } from "@/types/employees/employee.types.ts";

export enum ApiEmployeeEmploymentHistoryItemType {
  employment = "employment",
  termination = "termination",
}

export interface ApiEmployeeEmploymentHistoryItem {
  type: ApiEmployeeEmploymentHistoryItemType;
  date_effective_from: Date | null;
  employment: ApiEmployeeEmployment;
  termination: ApiEmployeeTerminationFull;
  changed_by?: ApiEmployee | null;
}

export interface ApiEmployeeEmploymentHistoryPendingItem {
  id: number | null;
  type: ApiEmployeeEmploymentHistoryItemType;
  date_effective_from: Date | null;
  employment: ApiEmployeeEmployment | null;
  termination: ApiEmployeeTerminationFull | null;
  changed_by?: ApiEmployee | null;
  pending: ApiTableRowPending;
}

export interface ApiEmployeeEmploymentHistoryData {
  items: ApiEmployeeEmploymentHistoryItem[];
  pending_rows: ApiEmployeeEmploymentHistoryPendingItem[];
}
